<template>
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8202 7.66198C14.4711 7.01111 15.5263 7.01111 16.1772 7.66198L27.8439 19.3287C28.4948 19.9795 28.4948 21.0348 27.8439 21.6857L16.1772 33.3523C15.5263 34.0032 14.4711 34.0032 13.8202 33.3523C13.1693 32.7015 13.1693 31.6462 13.8202 30.9953L24.3083 20.5072L13.8202 10.019C13.1693 9.36813 13.1693 8.31286 13.8202 7.66198Z"
      :fill="decideColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String, // active (red), inactive (grey), filled (white)
      required: false,
      default: 'inactive'
    }
  },
  computed: {
    decideColor() {
      if (this.color === 'inactive') {
        return '#CCCCCC'
      } else  {
        return '#B82025'
      } 
    }
  }
}
</script>
